import { CREDENTIALS } from "@/config";
import { CheckCircle2 } from "lucide-react";

export const Credentials = () => {
  return (
    <section
      id="credentials"
      data-testid="credentials-section"
      className="border-b border-[#EAEAEA] bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="overline">Credentials</div>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-4 leading-[1.05]">
            A background most tutoring businesses can&apos;t honestly claim.
          </h2>
          <p className="mt-6 text-[#4A4A52] leading-relaxed">
            Exceptional outcomes demand exceptional training. Every piece of work I take on is
            informed by classroom teaching, university-level instruction, and
            professional writing experience.
          </p>
          <div className="mt-10 aspect-[4/3] w-full max-w-[320px] bg-[#F3F4F6] border border-[#EAEAEA] overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1519452575417-564c1401ecc0?fm=jpg&q=80&w=900&auto=format&fit=crop"
              alt="Warm-lit university lecture hall"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="lg:col-span-8">
          <ul className="divide-y divide-[#EAEAEA] border-t border-b border-[#EAEAEA]">
            {CREDENTIALS.map((c, i) => (
              <li
                key={i}
                data-testid={`credential-${i}`}
                className="flex items-baseline justify-between gap-8 py-6 md:py-8 group"
              >
                <div className="flex items-baseline gap-6">
                  <span className="font-display text-sm tabular-nums text-[#4A4A52] w-8">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-xl md:text-3xl font-medium tracking-tight text-[#0A0A0B]">
                    {c.label}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-right">
                  <span className="text-xs md:text-sm uppercase tracking-[0.18em] text-[#4A4A52]">
                    {c.detail}
                  </span>
                  <CheckCircle2 size={18} className="text-[#0A192F] opacity-60 group-hover:opacity-100 transition-opacity" />
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
